import React, {useEffect, useState} from 'react';

import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {service as ConservationActionService} from  "../../../Services/ConservationActionService";

import {SurveyPage} from './SurveyPage';
import {AncillaryBenefits} from './AncillaryBenefits'
import {RiskAssessments} from './RiskAssessments'
import {ModeledUpliftSurveySection} from "./ModeledUpliftSurveySection";


export const EligibilityPage = props => {
    const makePageRequest = useMakePageRequest();

    const [conservationAction, setConservationAction] = useState(null);
    const conservationActionId = props.match.params.conActId;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        //if this is a new conservationAction we should only load a subset of the needed data.
        if(conservationActionId === "new") {
            //redirect
        } else {
            makePageRequest(
                () => Promise.all([
                    ConservationActionService.Get(conservationActionId)
                ]),
                ([conservationAction]) => {
                    setConservationAction(conservationAction.result);
                }
            );
        }
    };

    if(!conservationAction) {
        return null;
    }

    return <SurveyPage
            className="sb-conservation-actions-eligibility-page"
            ConservationAction={conservationAction}
            ConservationActionTypeId={conservationAction.conservationActionTypeId}
            OnConservationActionChange={setConservationAction}
            SurveyTypeId={2}
            SurveyFormProps={{
                CustomSections: {
                    "customAncillaryBenefits": AncillaryBenefits,
                    "customRiskAssessment": RiskAssessments,
                    "customModeledUplift": ModeledUpliftSurveySection
                }
            }}
            {...props}
        />;
};


